import { render, staticRenderFns } from "./ReportDetailDetail.vue?vue&type=template&id=2d298056&scoped=true&"
import script from "./ReportDetailDetail.vue?vue&type=script&lang=js&"
export * from "./ReportDetailDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailDetail.vue?vue&type=style&index=0&id=2d298056&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d298056",
  null
  
)

export default component.exports